import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import { useAuth } from '../../contexts/AuthContext';
import {
    IlgiliKayit, TakipOzet, TakipKullanici, TAKIP_RENKLERI, ilgiliMeta, hataMesaji, takipDegisti, boyutEtiketi, bugunStr,
} from './takipOrtak';
import './takip.css';

interface KullaniciListesi { yoneticiMi: boolean; atanabilir: TakipKullanici[]; tum: TakipKullanici[]; }

let kullaniciOnbellek: { zaman: number; veri: KullaniciListesi } | null = null;
export async function takipKullanicilariGetir(): Promise<KullaniciListesi> {
    if (kullaniciOnbellek && Date.now() - kullaniciOnbellek.zaman < 5 * 60 * 1000) return kullaniciOnbellek.veri;
    const r = await axiosInstance.get('/api/Takipler/kullanicilar');
    kullaniciOnbellek = { zaman: Date.now(), veri: r.data };
    return r.data;
}

const MAX_DOSYA = 10 * 1024 * 1024;

interface Props {
    mevcut?: TakipOzet | null;                          // düzenleme
    ilgili?: IlgiliKayit | null;                        // kayda bağlı yeni takip
    ustTakip?: { todoID: number; baslik: string } | null; // alt takip: başka kullanıcıdan bilgi / süreç talebi
    onKapat: () => void;
    onKaydedildi?: (t: TakipOzet) => void;
}

const TakipFormModal: React.FC<Props> = ({ mevcut, ilgili, ustTakip, onKapat, onKaydedildi }) => {
    const { user } = useAuth();
    const ben = user?.kullaniciID ?? 0;
    const talepModu = !!ustTakip || mevcut?.ustTakipID != null;

    const [kullanicilar, setKullanicilar] = useState<KullaniciListesi | null>(null);
    const [baslik, setBaslik] = useState(mevcut?.baslik ?? '');
    const [aciklama, setAciklama] = useState(mevcut?.aciklama ?? '');
    const [tarihVar, setTarihVar] = useState(!!mevcut?.gorevTarihi);
    const [tarih, setTarih] = useState(mevcut?.gorevTarihi ?? '');
    const [saat, setSaat] = useState(mevcut?.baslangicSaati ?? '');
    const [atanan, setAtanan] = useState<number | ''>(mevcut?.kullaniciID ?? (ustTakip ? '' : ben));
    const [talepTuru, setTalepTuru] = useState<'BILGI' | 'SUREC'>(mevcut?.talepTuru ?? 'BILGI');
    const [renk, setRenk] = useState(mevcut?.renk ?? TAKIP_RENKLERI[5]);
    const [dosyalar, setDosyalar] = useState<File[]>([]);
    const [kaydediliyor, setKaydediliyor] = useState(false);
    const [hata, setHata] = useState('');
    const dosyaRef = useRef<HTMLInputElement>(null);
    const baslikRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        takipKullanicilariGetir().then(setKullanicilar).catch(() => setKullanicilar({ yoneticiMi: false, atanabilir: [], tum: [] }));
        setTimeout(() => baslikRef.current?.focus(), 50);
    }, []);

    useEffect(() => {
        const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') onKapat(); };
        window.addEventListener('keydown', esc);
        return () => window.removeEventListener('keydown', esc);
    }, [onKapat]);

    const secenekler: TakipKullanici[] = !kullanicilar ? []
        : talepModu ? kullanicilar.tum.filter(k => k.kullaniciID !== ben || mevcut?.kullaniciID === ben)
        : kullanicilar.atanabilir;
    // Düzenlemede mevcut sorumlu listede yoksa (ör. üst yöneticinin atadığı) yine de göster
    const mevcutSorumluYok = mevcut && !secenekler.some(k => k.kullaniciID === mevcut.kullaniciID);

    const ilgiliGoster = mevcut?.ilgiliTur
        ? { tur: mevcut.ilgiliTur, baslik: mevcut.ilgiliBaslik ?? '' }
        : ilgili ? { tur: ilgili.tur, baslik: ilgili.baslik } : null;
    const meta = ilgiliMeta(ilgiliGoster?.tur);

    const dosyaEkle = (liste: FileList | null) => {
        if (!liste) return;
        const yeni = Array.from(liste);
        const buyuk = yeni.filter(f => f.size > MAX_DOSYA);
        if (buyuk.length) setHata(`${buyuk.map(f => f.name).join(', ')}: dosya boyutu en fazla 10 MB olabilir.`);
        setDosyalar(prev => [...prev, ...yeni.filter(f => f.size <= MAX_DOSYA)]);
    };

    const kaydet = async () => {
        if (!baslik.trim()) { setHata('Başlık girin.'); return; }
        if (talepModu && !atanan) { setHata('Talep edilecek kişiyi seçin.'); return; }
        if (tarihVar && !tarih) { setHata('Tarih seçin ya da tarihi kaldırın.'); return; }
        setKaydediliyor(true); setHata('');
        const govde = {
            baslik: baslik.trim(),
            aciklama: aciklama.trim() || null,
            kullaniciID: atanan || null,
            renk,
            gorevTarihi: tarihVar ? tarih : null,
            baslangicSaati: tarihVar && saat ? saat : null,
            bitisSaati: tarihVar ? (mevcut?.bitisSaati ?? null) : null,
            ilgiliTur: mevcut ? undefined : ilgili?.tur ?? null,
            ilgiliAnahtar: mevcut ? undefined : ilgili ? String(ilgili.anahtar) : null,
            ilgiliBaslik: mevcut ? undefined : ilgili?.baslik ?? null,
            ustTakipID: mevcut ? undefined : ustTakip?.todoID ?? null,
            talepTuru: talepModu ? talepTuru : null,
        };
        try {
            const r = mevcut
                ? await axiosInstance.put(`/api/Takipler/${mevcut.todoID}`, govde)
                : await axiosInstance.post('/api/Takipler', govde);
            const kayit: TakipOzet = r.data;
            const yuklenemeyen: string[] = [];
            for (const f of dosyalar) {
                const fd = new FormData();
                fd.append('dosya', f);
                try { await axiosInstance.post(`/api/Takipler/${kayit.todoID}/dosya`, fd); }
                catch { yuklenemeyen.push(f.name); }
            }
            if (yuklenemeyen.length) alert(`Takip kaydedildi ancak şu dosyalar yüklenemedi: ${yuklenemeyen.join(', ')}`);
            takipDegisti();
            onKaydedildi?.({ ...kayit, dosyaSayisi: kayit.dosyaSayisi + dosyalar.length - yuklenemeyen.length });
            onKapat();
        } catch (e) {
            setHata(hataMesaji(e));
        } finally {
            setKaydediliyor(false);
        }
    };

    const baslikMetni = mevcut ? 'Takibi Düzenle' : ustTakip ? 'Bilgi / Süreç Talep Et' : 'Yeni Takip';

    return (
        <div className="tkp-perde ust" onMouseDown={e => { if (e.target === e.currentTarget) onKapat(); }}>
            <div className="tkp-modal dar">
                <div className="tkp-modal-bas">
                    <i className={`fas ${ustTakip ? 'fa-hand-paper' : 'fa-tasks'}`} style={{ color: '#e67d21' }}></i>
                    <h5>{baslikMetni}</h5>
                    <button className="tkp-kapat" onClick={onKapat}>×</button>
                </div>
                <div className="tkp-modal-govde">
                    {hata && <div className="tkp-hata">{hata}</div>}

                    {(ilgiliGoster || ustTakip) && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                            {ilgiliGoster && meta && (
                                <span className="tkp-ilgili"><i className={`fas ${meta.ikon}`} style={{ color: meta.renk }}></i><span>{meta.ad}: {ilgiliGoster.baslik}</span></span>
                            )}
                            {ustTakip && (
                                <span className="tkp-ilgili"><i className="fas fa-level-up-alt" style={{ color: '#6d28d9' }}></i><span>Üst takip: {ustTakip.baslik}</span></span>
                            )}
                        </div>
                    )}

                    <div className="tkp-alan">
                        <label className="tkp-etiket">{talepModu ? 'Talep' : 'Başlık'} *</label>
                        <input ref={baslikRef} className="tkp-girdi" value={baslik} maxLength={500}
                            onChange={e => setBaslik(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') kaydet(); }}
                            placeholder={talepModu ? 'Ne talep ediyorsunuz? (ör. Tapu fotokopisi gönderilmesi)' : 'Takip başlığı'} />
                    </div>

                    {talepModu && (
                        <div className="tkp-alan">
                            <label className="tkp-etiket">Talep türü</label>
                            <div style={{ display: 'flex', gap: 8 }}>
                                {([['BILGI', 'Bilgi talebi', 'fa-info-circle'], ['SUREC', 'Süreç talebi', 'fa-cogs']] as const).map(([d, ad, ikon]) => (
                                    <button key={d} type="button" className={`tkp-btn ${talepTuru === d ? 'ana' : ''}`} onClick={() => setTalepTuru(d)}>
                                        <i className={`fas ${ikon}`}></i>{ad}
                                    </button>
                                ))}
                            </div>
                            <div className="tkp-ipucu">
                                {talepTuru === 'BILGI' ? 'Kişiden bir bilgi istenir; cevabını takibe not olarak yazar.' : 'Kişiden bir işlemin yapılması istenir; tamamladığında işaretler.'}
                            </div>
                        </div>
                    )}

                    <div className="tkp-alan">
                        <label className="tkp-etiket">Açıklama</label>
                        <textarea className="tkp-girdi" rows={4} value={aciklama} onChange={e => setAciklama(e.target.value)} placeholder="Ayrıntılar (isteğe bağlı)" />
                    </div>

                    <div className="tkp-satir">
                        <div className="tkp-alan">
                            <label className="tkp-etiket">{talepModu ? 'Talep edilecek kişi *' : 'Sorumlu'}</label>
                            <select className="tkp-girdi" value={atanan} onChange={e => setAtanan(e.target.value ? Number(e.target.value) : '')}
                                disabled={!kullanicilar || (!talepModu && secenekler.length <= 1 && !mevcutSorumluYok)}>
                                {talepModu && <option value="">Seçin…</option>}
                                {mevcutSorumluYok && <option value={mevcut!.kullaniciID}>{mevcut!.kullaniciAdi}</option>}
                                {secenekler.map(k => (
                                    <option key={k.kullaniciID} value={k.kullaniciID}>{k.kullaniciID === ben ? `${k.adSoyad} (ben)` : k.adSoyad}</option>
                                ))}
                            </select>
                            {!talepModu && kullanicilar && !kullanicilar.yoneticiMi && (
                                <div className="tkp-ipucu">Başka birinden bilgi/süreç için takibin detayından <b>Talep Et</b>'i kullanın.</div>
                            )}
                        </div>
                        <div className="tkp-alan">
                            <label className="tkp-etiket" style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                                <input type="checkbox" checked={tarihVar} onChange={e => { setTarihVar(e.target.checked); if (e.target.checked && !tarih) setTarih(bugunStr()); }} style={{ accentColor: '#e67d21' }} />
                                Tarih (isteğe bağlı)
                            </label>
                            <div style={{ display: 'flex', gap: 6 }}>
                                <input type="date" className="tkp-girdi" value={tarih} disabled={!tarihVar} onChange={e => setTarih(e.target.value)} />
                                <input type="time" className="tkp-girdi" value={saat} disabled={!tarihVar} onChange={e => setSaat(e.target.value)} style={{ maxWidth: 110 }} title="Saat (isteğe bağlı)" />
                            </div>
                        </div>
                    </div>

                    <div className="tkp-alan">
                        <label className="tkp-etiket">Renk</label>
                        <div style={{ display: 'flex', gap: 8 }}>
                            {TAKIP_RENKLERI.map(c => (
                                <button key={c} type="button" onClick={() => setRenk(c)} style={{
                                    width: 22, height: 22, borderRadius: '50%', background: c, cursor: 'pointer', padding: 0,
                                    border: renk === c ? '2.5px solid #1a2440' : '2px solid #d1d5db', transform: renk === c ? 'scale(1.15)' : 'none',
                                }} />
                            ))}
                        </div>
                    </div>

                    <div className="tkp-alan">
                        <label className="tkp-etiket">Dosyalar</label>
                        <input ref={dosyaRef} type="file" multiple style={{ display: 'none' }} onChange={e => { dosyaEkle(e.target.files); e.target.value = ''; }} />
                        <button type="button" className="tkp-btn kucuk" onClick={() => dosyaRef.current?.click()}><i className="fas fa-paperclip"></i>Dosya ekle</button>
                        <span className="tkp-ipucu" style={{ marginLeft: 8 }}>En fazla 10 MB / dosya</span>
                        {dosyalar.map((f, i) => (
                            <div key={i} className="tkp-dosya">
                                <i className="fas fa-file" style={{ color: '#9ca3af' }}></i>
                                <span className="ad" style={{ cursor: 'default' }}>{f.name}</span>
                                <span className="kucuk">{boyutEtiketi(f.size)}</span>
                                <button className="tkp-ikon-btn" onClick={() => setDosyalar(prev => prev.filter((_, j) => j !== i))}><i className="fas fa-times"></i></button>
                            </div>
                        ))}
                        {mevcut && mevcut.dosyaSayisi > 0 && <div className="tkp-ipucu">Mevcut {mevcut.dosyaSayisi} dosya detay ekranından yönetilir.</div>}
                    </div>
                </div>
                <div className="tkp-modal-alt">
                    <button className="tkp-btn" onClick={onKapat}>Vazgeç</button>
                    <button className="tkp-btn ana" onClick={kaydet} disabled={kaydediliyor}>
                        {kaydediliyor ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-check"></i>}
                        {mevcut ? 'Kaydet' : ustTakip ? 'Talep Gönder' : 'Takip Ekle'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TakipFormModal;
